module.exports = __webpack_public_path__ + "img/男-慢性阻塞性肺病h.2098606f.png";